const useSessionStorage = <T>(
  key: string,
): [T | null, (nextValue: T) => void, () => void] => {
  const sessionStorageValue = window.sessionStorage.getItem(key);
  const value = sessionStorageValue
    ? (JSON.parse(sessionStorageValue) as T)
    : null;

  const setValue = (nextValue: T) => {
    window.sessionStorage.setItem(key, JSON.stringify(nextValue));
  };

  const removeValue = () => {
    window.sessionStorage.removeItem(key);
  };

  return [value, setValue, removeValue];
};

export default useSessionStorage;
